import dayjs, { Dayjs } from 'dayjs';
import { WorktimesRequest } from '../../store/slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsSlice';
import { TimeSheetPageState } from '../../store/slices/timesheet/timesheetPageSlice';

const getFilteredWorkTime = (workTime: WorktimesRequest): WorktimesRequest => {
  return {
    timeSheetApprovalWorkTimesId: workTime?.timeSheetApprovalWorkTimesId
      ? workTime.timeSheetApprovalWorkTimesId
      : undefined,
    startTime:
      workTime.startTime !== null
        ? String(workTime.startTime)
        : String(dayjs(null)),
    endTime:
      workTime.endTime !== null
        ? String(workTime.endTime)
        : String(dayjs(null)),
    isClean: workTime.isClean,
  };
};

export const handleInitialWorkTimes = (
  data: TimeSheetPageState,
  processed: boolean,
): WorktimesRequest[] => {
  const filteredWorkTimes: WorktimesRequest[] = [];
  const workTimes: WorktimesRequest[] = !processed
    ? data.workTimes
    : data.approval?.timeSheetApprovalWorkTimes || [];
  for (let i = 0; i < workTimes.length; i++) {
    filteredWorkTimes[i] = getFilteredWorkTime(workTimes[i]);
  }
  return filteredWorkTimes;
};

export const workTimeChecker = (
  data: { startTime: string | null; endTime: string | null }[],
) => {
  let isOnError = false;
  for (let i = 0; i < data.length; i++) {
    const startTime: Dayjs = dayjs(data[i].startTime);
    const endTime: Dayjs = dayjs(data[i].endTime);
    isOnError = !startTime.isValid() || !endTime.isValid();
    if (isOnError) {
      if (i > 0 && !(startTime.isValid() || endTime.isValid())) {
        const previousStartTime: Dayjs = dayjs(data[i - 1].startTime);
        const previousEndTime: Dayjs = dayjs(data[i - 1].endTime);
        isOnError = !(previousStartTime.isValid() && previousEndTime.isValid());
      }
      break;
    }
  }
  return isOnError;
};
